module.exports = __webpack_public_path__ + "img/webnew-salon2-content4.36a61d33.png";